var root = { exports: {} };
export {
  root as __module
};
//# sourceMappingURL=root.js.map
